<template>
  <div class="home">
    <Intro />
    <Product />
    <Workflow />
    <TryFree />
    <Price />
    <About />
  </div>
</template>

<script>
// @ is an alias to /src
import Intro from '@/components/views/Intro.vue'
import Product from '@/components/views/Product.vue'
import About from '@/components/views/About.vue'
import Price from '@/components/views/Price.vue'
import TryFree from '@/components/views/TryFree.vue'
import Workflow from '@/components/views/Workflow.vue'

export default {
  name: 'home',
  components: {
    Intro,
    Product,
    About,
    Price,
    TryFree,
    Workflow
  }
}
</script>
